import {useQuery} from '@tanstack/react-query';
import {RefundProfessionalCouncilsParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundProfessionalCouncils} from '../services/getRefundProfessionalCouncils';

export const useGetRefundProfessionalCouncilsQuery = (params: RefundProfessionalCouncilsParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_PROFESSIONAL_COUNCILS, params],
		queryFn: ({signal}) => getRefundProfessionalCouncils({signal, ...params}),
		enabled: false,
	});
